import { integrationAxios } from "./Axios";

export const handleShopifyLoginUtil = async (
  shop: string | null,
  code: string | null,
  state: any | null,
  showAlert: (msg: string, type: "success" | "error") => void,
  closeWindow: boolean = true,
  postMessageOrigin: string = process.env.REACT_APP_SHOPIFY_APP_URL || "https://wabo-shopify-app.wabo.ai"
) => {
  if (!shop || !code) {
    console.warn("Missing shop or code for Shopify login");
    return;
  }

  try {
    // 🔗 Build callback API URL
    let sf_url = `/integrations/shopify-app-setup?shop=${shop}&accessToken=${code}`;
    if (state) sf_url += `&state=${state}`;

    const res = await integrationAxios.get(sf_url);

    // ✅ Success alert
    showAlert("App installed successfully", "success");

    // 🔄 Post message back to parent (Wabo App)
    if (window.opener) {
      window.opener.postMessage(
        { type: "WABO_LOGIN_SUCCESS", shop, code, state },
        postMessageOrigin // 🔒 configurable origin
      );
      if(closeWindow){
      window.close();
      }
    }
  } catch (err: any) {
    console.error("Shopify login error:", err);
    showAlert(err?.response?.data?.error || "Unable to fetch Data", "error");
  }
};
